import { useState, useCallback } from "react";

interface FlashcardData {
  id: string;
  front: string;
  back: string;
}

interface FlashcardProps {
  flashcards: FlashcardData[];
}

export default function Flashcard({ flashcards }: FlashcardProps) {
  const [cards, setCards] = useState(flashcards);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);

  const shuffle = useCallback(() => {
    const shuffled = [...cards].sort(() => Math.random() - 0.5);
    setCards(shuffled);
    setCurrentIndex(0);
    setFlipped(false);
  }, [cards]);

  const goNext = () => {
    if (currentIndex < cards.length - 1) {
      setCurrentIndex((i) => i + 1);
      setFlipped(false);
    }
  };

  const goPrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((i) => i - 1);
      setFlipped(false);
    }
  };

  if (cards.length === 0) return <p className="empty-msg">No flashcards available</p>;

  const card = cards[currentIndex];

  return (
    <div className="flashcard-wrapper">
      <div className="flashcard-controls-top">
        <span className="flashcard-counter">
          {currentIndex + 1} / {cards.length}
        </span>
        <button className="shuffle-btn" onClick={shuffle}>
          Shuffle
        </button>
      </div>

      <div
        className={`flashcard-container ${flipped ? "flipped" : ""}`}
        onClick={() => setFlipped(!flipped)}
      >
        <div className="flashcard-inner">
          <div className="flashcard-front">
            <div className="flashcard-label">Q</div>
            <div className="flashcard-text">{card.front}</div>
            <div className="flashcard-hint">Click to flip</div>
          </div>
          <div className="flashcard-back">
            <div className="flashcard-label">A</div>
            <div className="flashcard-text">{card.back}</div>
          </div>
        </div>
      </div>

      <div className="flashcard-controls">
        <button onClick={goPrev} disabled={currentIndex === 0}>
          Prev
        </button>
        <button onClick={goNext} disabled={currentIndex === cards.length - 1}>
          Next
        </button>
      </div>
    </div>
  );
}
